import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Les trois familles du design system Elyadata : Archivo pour les titres, Inter
// pour le texte, JetBrains Mono pour les chiffres et les données.
import '@fontsource-variable/archivo';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';

import './styles/tokens.css';
import './styles/app.css';

import { Application } from './Application';
import { FournisseurSession } from './auth/session';

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément #racine absent de index.html');

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter>
      <FournisseurSession>
        <Application />
      </FournisseurSession>
    </BrowserRouter>
  </StrictMode>,
);
